import axios from "axios";

const axiosClient = axios.create({
  // baseURL: "http://localhost:6011",
  // baseURL: "https://tktapi.estudent.uz",
  baseURL: "https://api-mock.edu-action.uk",
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    throw error;
  },
);

export default axiosClient;
